<template>
    <div>
        <div v-if="config">
            <a-table :columns="config.columns" :data-source="data" :scroll="{ x: true }"
                :pagination="{ pageSize: 5 }" bordered />
        </div>

        <a-modal v-model:open="tableModalVisible" title="Preview" footer="">
            <a-image v-if="props.type === 'imagens'" :src="imgUrl" alt="preview da imagem" :preview="false" />
            <div v-else v-html="htmlPreview" style="max-height: 750px; overflow-y: auto"></div>
        </a-modal>
    </div>
</template>

<script setup>
import {computed, h, ref, onMounted, watch} from 'vue'
import {Button, message, Tooltip} from 'ant-design-vue';
import {CopyOutlined, EyeOutlined} from "@ant-design/icons-vue";

const tableModalVisible = ref(false)
const htmlPreview = ref();
const imgUrl = ref(null);

const props = defineProps({
    type: String,
})

const handlePreview = (value) => {
    if (props.type === 'imagens') {
        imgUrl.value = window.location.origin + value;
        tableModalVisible.value = true
    } else {
        htmlPreview.value = value
        tableModalVisible.value = true
    }
}

const handleCopy = (record) => {
    let texto = ''
    if (props.type === 'imagens') {
        texto = `<img height="100%" width="100%" src="${record.path}" />`
    } else {
        texto = `<a data-id="${record.id}">${record.name}</a>`
    }
    navigator.clipboard.writeText(texto).then(() => {
        message.success('Copiado!')
    }).catch(() => {
        message.error('Erro ao copiar')
    })
}

const configs = {
    siglas: {
        columns: [
            {title: 'ID', dataIndex: 'id', key: 'id'},
            {
                title: 'Siglas', dataIndex: 'name', key: 'name', customRender: ({text}) => {
                    const maxLength = 12
                    if (!text) return ''
                    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text
                }
            },
        ],
        endpoint: '/api/viabilidade/siglas',
    },
    imagens: {
        columns: [
            {title: 'Nome', dataIndex: 'name', key: 'name'},
            {title: 'Caminho', dataIndex: 'path', key: 'path'},
        ],
        endpoint: '/api/configurations/client-images',
    },
    faqs: {
        columns: [
            {title: 'ID', dataIndex: 'id', key: 'id'},
            {
                title: 'Nome', dataIndex: 'name', key: 'name', customRender: ({text}) => {
                    const maxLength = 12
                    if (!text) return ''
                    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text
                }
            },
            {title: 'Tutorial principal', dataIndex: 'isMain', key: 'isMain', customRender: ({text}) => (text ? 'Sim' : 'Não')},
        ],
        endpoint: '/api/configurations/faqs',
    },
}

const config = computed(() => {
    const baseConfig = configs[props.type]
    if (!baseConfig) return {}

    const actionColumn = { title: 'Ações', key: 'actions', align: 'center',
        customRender: ({record}) =>
            h('div', {style: {display: 'flex', gap: '5px', justifyContent: 'center'}}, [
                h(Tooltip, {title: 'Preview'}, {
                    default: () => h(Button, {
                        type: 'text',
                        style: {
                            backgroundColor: 'green',
                            color: 'white',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        },
                        icon: h(EyeOutlined),
                        onClick: () => {
                            const valueToSend = props.type === 'imagens' ? record.path : record.html
                            handlePreview(valueToSend)
                        }
                    })
                }),

                h(Tooltip, {title: 'Copiar tag'}, {
                    default: () => h(Button, {
                        type: 'primary',
                        style: {display: 'flex', justifyContent: 'center', alignItems: 'center'},
                        icon: h(CopyOutlined),
                        onClick: () => handleCopy(record)
                    })
                })
            ])
    }

    return {...baseConfig, columns: [...baseConfig.columns, actionColumn]}
})

const data = ref([])

const fetchData = async () => {
    if (config.value?.endpoint) {
        try {
            const response = await window.axios.get(config.value.endpoint)
            data.value = response.data.data
        } catch (err) {
            console.error('Erro ao buscar dados:', err)
        }
    }
}

onMounted(fetchData)
watch(() => props.type, fetchData)
</script>

<style>
.ant-table-thead > tr > th {
    padding: 10px 15px !important;
}

.ant-table-tbody > tr > td {
    padding: 10px 15px !important;
}
</style>